// extracted by mini-css-extract-plugin
export default {"Button":"WelcomeLinks_Button__Tom9i","WhiteButton":"WelcomeLinks_WhiteButton__J90-L","OrangeButton":"WelcomeLinks_OrangeButton__bSRud","UserPhoto":"WelcomeLinks_UserPhoto__3mdJd"};